var utils = require('../../utils')
import AppHeaderNoauth from '../AppHeaderNoauth'
export default {
  name: 'forgot-password',
  utils: utils,
  data: function () {
    return {
      email: null,
      isSuccess: false,
      message: null,
      showMessage: false,
      border: null
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
  },
  computed: {
    isForgotPasswordSuccess () {
      return (this.$store.getters.authStatus === 'success')
    }
  },
  components: {
    AppHeaderNoauth
  },
  methods: {
    /** 送信可否 */
    canSubmit: function () {
      if (utils.isBlank(this.email)) {
        return false
      }
      if (!utils.isEmail(this.email)) {
        return false
      }
      return true
    },
    /** メール送信 */
    sendMail: function () {
      if (!this.email) {
        this.message = 'メールアドレスを入力してください'
        this.showMessage = true
        return
      }
      this.showMessage = false
      var resetUrl = location.href
      resetUrl = resetUrl.substr(0, resetUrl.lastIndexOf('#')) + '#/reset_password'
      var form = new FormData()
      form.append('email', this.email)
      form.append('reset_url', resetUrl)
      this.$store.dispatch('PASSWORD_RESET_MAIL_SEND', {data: form})
      .then(
        (res) => {
          this.message = this.$t('forgot_password.completed')
          this.showMessage = true
        },
        () => {
          this.message = this.$store.getters.authError || this.$store.getters.apiError
          this.showMessage = true
          this.border = 'border: thin solid #dd6f60;'
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/forgot-password.js